import React from "react";
import HeroSection from "./../../components/HeroSection/HeroSection";
import StatsSection from "../../components/StatsSection/StatsSection";
import Testimonials from "../../components/Testimonials/Testimonials";
import StonesSelector from "../../components/StonesSelector/StonesSelector";
import ContactCTA from "../../components/ContactCTA/ContactCTA";
import styles from "./Home.module.css";
import image from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/8.JPG";

const Home = () => (
  <main className={styles.homePage}>
    <HeroSection />
    <StatsSection />
    <div className={styles.featuredProject}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Distinguished Feature</h2>
          <p className={styles.sectionSubtitle}>Exemplary craftsmanship in stone architecture</p>
        </div>
        <div className={styles.projectContent}>
          <div className={styles.projectImage}>
            <div className={styles.imageWrapper}>
              <img src={image} alt="Clock Tower - Nuwara Eliya" />
            </div>
          </div>
          <div className={styles.projectInfo}>
            <h3 className={styles.projectTitle}>Clock Tower - Nuwara Eliya</h3>
            <div className={styles.divider}></div>
            <p className={styles.projectDescription}>
              Our majestic stone tower stands as a testament to architectural excellence. Featuring hand-carved stone details and traditional joinery techniques, this structure demonstrates our dedication to reviving the grandeur of Victorian public monuments.
            </p>
            <ul className={styles.projectFeatures}>
              <li>Premium local granite with imported marble accents</li>
              <li>Gothic revival detailing with period-authentic elements</li>
              <li>Master craftsman stone carving and ornate flourishes</li>
              <li>Heritage-inspired weather-resistant construction</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.decorativeBottom}></div>
    </div>
    <StonesSelector />
    {/* <Testimonials /> */}
    <ContactCTA />
  </main>
);

export default Home;